import { render } from "./HeaderV.vue?vue&type=template&id=5a9a5532&scoped=true&ts=true"
import script from "./HeaderV.vue?vue&type=script&lang=ts"
export * from "./HeaderV.vue?vue&type=script&lang=ts"

import "./HeaderV.vue?vue&type=style&index=0&id=5a9a5532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9a5532"]])

export default __exports__